import type {GlobalConfig} from "./types";
import {PageType} from "./types";

export const GLOBAL_CONFIG: GlobalConfig = {
    mainSettings: {
        grade: "Физика. 10 класс",
        subject: "Температура и её измерение. Абсолютная температура",
        mainColor: "./images/bg_img.png",
        secondColor: "rgba(250, 219, 187, 0.8)",
    },
    home: {
        title: "Температура и её измерение. Абсолютная температура",
        authorsTitle: "Автор",
        authors: [
            {
                author: "Пчёлкина М.А.",
                grade: "научный сотрудник",
                subGrade: " ",
                imageSrc: "./images/author_1.png"
            },
            {
                author: "Никифоров Г.Г.",
                grade: "к.пед.н.",
                subGrade: " ",
                imageSrc: "./images/author_2.png"
            },
            {
                author: "Андреева Н.В.",
                grade: "почётный работник ОО РФ",
                subGrade: " ",
                imageSrc: "./images/author_3.png"
            }
        ],
        imagePath: "./images/title_img.png",
    },
    pages: [
        {
            order: 1,
            nextBtnName: "Далее",
            pdfPath: "./files/additional_information.pdf",
            type: PageType.ANNOTATION,
            imagePath: "",
            content: [
                {
                    type: "block",
                    children: [
                        {
                            type: "block",
                            text: "<div style='background: #E7F1FF; border-radius: 16px; padding: 2.4rem;'>Тема «Температура и её измерение. Абсолютная температура» изучается в 10 классе в разделе «Молекулярная физика и термодинамика».</div>"
                        },
                        {
                            type: "block",
                            text: "<p style='padding-left: 2.4rem;'>Поскольку температуру как величину, количественно выражающую интуитивное представление о нагретости тел и характеризующую направление теплообмена, невозможно измерить непосредственно, для её измерения используют функциональную зависимость от неё других параметров термометрических тел (объём, давление, электрическое сопротивление и прочее).  </p>"
                        },
                        {
                            type: "block",
                            text: "<p style='padding-left: 2.4rem;'>Поэтому само измерение температуры, разработка термометрических принципов и методов представляло собой непростую задачу для физики как науки, а формирование представлений о принципах и методах термометрии является непростой задачей при обучении физике. </p>"
                        },
                        {
                            type: "block",
                            text: "<p style='padding-left: 2.4rem;'>Методы измерения температуры отличаются от тех, с которыми школьники сталкивались раньше. Для их понимания необходимы формирование начальных представлений о состояниях термодинамических систем, знания и умения применять уравнения связи между основными термодинамическими величинами T, V, p, n, Е ̅; представления об относительных (эмпирических) и абсолютных температурных шкалах, принципах их построения. Особенно выделяется проблема определения эмпирически недостижимого абсолютного нуля.</p>"
                        },
                        {
                            type: "block",
                            text: "<p style='padding-left: 2.4rem;'>Вместе с тем, глубокое понимание темы «Температура и её измерение. Абсолютная температура» необходимо для дальнейшего успешного освоения начал термодинамики. Всё это определяет методическую сложность преподавания данной темы.</p>"
                        },
                        {
                            type: "block",
                            text: "<p style='padding-left: 2.4rem;'>В данном методическом кейсе будет представлена методика преподавания темы «Температура и её измерение. Абсолютная температура» на основе самостоятельного исследования обучающихся по оценке значения абсолютного нуля температуры. Исследуя зависимость давления воздуха от температуры в градусах Цельсия при постоянном объёме, ученики экстраполируют её в отрицательную область и определяют значение температуры при p=0.  </p>"
                        },
                        {
                            type: "block",
                            text: "<p style='padding-left: 2.4rem;'>В кейсе будет показана технология проведения исследования по оценке абсолютного нуля с использованием современного цифрового оборудования – цифровой лаборатории, которая позволяет обучающимся осваивать современные методы проведения физических исследований, способов получения и обработки информации, а также повышает точность и значительно экономит время проведения эксперимента. </p>"
                        },
                        {
                            type: "block",
                            text: "<p style='padding-left: 2.4rem;'>Учитель сможет убедиться, как выстраивание изучения темы с опорой на самостоятельное исследование создаёт на уроке атмосферу научного поиска и способствует более глубокому освоению материала. </p>"
                        },
                        {
                            type: "block",
                            text: "<p style='padding-left: 2.4rem;'>В кейсе будет показано, как:</p>" +
                                "<ul>" +
                                "<li>как устроена цифровая лаборатория и как она работает;</li>" +
                                "<li>сконструировать урок по циклу научного познания, создав условия для самостоятельного выдвижения учениками гипотезы и обоснования ими физического смысла абсолютного нуля температуры;</li>" +
                                "<li>организовать самостоятельное исследование обучающихся по оценке значения абсолютного нуля температуры с использованием цифровой лаборатории;</li>" +
                                "<li>использовать возможности современного цифрового оборудования – цифровой лаборатории – при организации экспериментальной деятельности школьников. </li>" +
                                "</ul>"
                        },
                    ]
                }
            ]
        },
        {
            order: 2,
            nextBtnName: "Далее",
            type: PageType.METHODOLOGICAL_MODULE,
            title: "Методические рекомендации",
            imagePath: "",
            id: "1",
            videoUrl: "./video/video.mp4",
            contentBefore: [{
                type: "text",
                text: ``
            }],
            contentAfter: [{
                type: "text",
                text: ``
            }]
        },
        {
            order: 3,
            nextBtnName: "Далее",
            type: PageType.INTERACTIVE,
            id: "1011",
            title: "Практический модуль",
            htmlPath: "./interactive/dist/index.html",
            autoHeight: false
        },
        {
            order: 4,
            nextBtnName: "Далее",
            type: PageType.ADDITIONAL_MATERIALS,
            imagePath: "",
            materials: [
                //   {link: "https://www.youtube.com/embed/CaaH2dUJqf8", title: "Последние загадки Гизы: египетские пирамиды"},
                //  {link: "https://www.youtube.com/embed/Mg7h_qYjs9k", title: "Тайна египетских пирамид Гизы"},
                //  {link: "https://www.youtube.com/embed/MVCTEz-2I0E", title: "Ленские столбы: заповедник"}
            ],
            literatures: [
                "Андреева Н. В., Пчёлкина М. А., Никифоров Г. Г. «ФГОС-лаборатория»: набор «Молекулярная физика и термодинамика», цифровая лаборатория базового уровня как фронтальное оборудование // Физика. 2016. № 1. Издательский дом «Первое сентября»",
                "Бурмин Г. С. Штурм абсолютного нуля: для ст. возраста. – Москва: Дет. лит., 1983",
                "Дуков В. М. Исторические обзоры в курсе физики средней школы: пособие для учителей. – Москва: Просвещение, 1983",
                "Мендельсон К. На пути к абсолютному нулю: Введение в физику низких температур / пер. с англ. В. П. Карцева, В. А. Кузьмичёвой. – Москва: Атомиздат, 1971",
                "Наука. Величайшие теории: выпуск 31: Физике становится тепло. Лорд Кельвин. Классическая термодинамика / пер. с исп. – Москва: Де Агостини, 2015",
                "Орлов В. А., Никифоров Г. Г. Равновесная и неравновесная термодинамика. Элективный курс: Учебное пособие. – Москва: БИНОМ. Лаборатория знаний, 2005",
                "Сивухин Д. В. Общий курс физики: учеб. пособие для вузов. В 5 т. – 4-е изд. – Москва: Физматлит; МФТИ, 2003. Т. 2: Термодинамика и молекулярная физика",
                "Цифровые лаборатории. Методическое руководство по работе с комплектом оборудования и программным обеспечением фирмы «Научные развлечения» / А. Н. Болгар, Н. К. Ханнанов. – Москва: «Научные развлечения», 2011",
            ],
            sites: [],
            filesToDownload: [
                {link: "./files/additional_information.pdf", fileName: "В чем ценность открытия электромагнитной индукции для каждого"},
            ]
        }
    ],
};
